import { useContext } from 'react';

import FeatureGates from '@atlaskit/feature-gate-js-client';

import { ConfluenceEdition } from '@confluence/change-edition';
import { SPAViewContext } from '@confluence/spa-view-context';
import { useSessionData } from '@confluence/session-data';

import { getTrialDaysLeft } from './getTrialDaysLeft';
import { isFumcSuppressed } from './isFumcSuppressed';

type UseIsFUMCEnabledProps = {
	trialEndDate?: string | null;
	skipTrialCheck?: boolean;
};

export const PREMIUM_FEATURES_USAGE_INSIGHTS_EXPERIMENT =
	'cc_editions_premium_features_usage_insights';

export enum Cohort {
	NOT_ENROLLED = 'not-enrolled',
	CONTROL = 'control',
	TEST = 'test',
}

const COHORT = 'cohort';

//FUMC experience is enabled only for site admins in confluence premium trial
export const useIsFUMCEnabled = ({
	trialEndDate = null,
	skipTrialCheck = false,
}: UseIsFUMCEnabledProps) => {
	const { edition } = useSessionData();
	const { isSiteAdmin } = useContext(SPAViewContext);
	const trialDaysLeft = getTrialDaysLeft(trialEndDate);

	const fumcFeatureFlag =
		edition === ConfluenceEdition.PREMIUM &&
		isSiteAdmin &&
		(skipTrialCheck || trialDaysLeft > 0) &&
		!isFumcSuppressed()
			? FeatureGates.getExperimentValue<string>(
					PREMIUM_FEATURES_USAGE_INSIGHTS_EXPERIMENT,
					COHORT,
					Cohort.NOT_ENROLLED,
				)
			: Cohort.NOT_ENROLLED;

	return {
		fumcFeatureFlag,
		isFUMCEnabled: fumcFeatureFlag === Cohort.TEST,
	};
};
